@let loaders = loaderService.loaders.$ | async;
@if (loaders.length > 0) {
    @if (hasBackdrop()) {
        <div class="bazis-backdrop"></div>
    }
    <div class="bazis-loader">
        <div class="bazis-loader__content">
            @if (loader() === 'dots') {
                <div class="bazis-loader__dots">
                    @for (item of [].constructor(amountDots()); track $index) {
                        <div class="bazis-loader__dot"></div>
                    }
                </div>
            }
            @if (loader() === 'spinner') {
                <svg class="bazis-loader__spinner">
                    <circle
                        [attr.cx]="centerX()"
                        [attr.cy]="centerY()"
                        [attr.r]="radius()"
                        fill="none"
                        stroke-width="1"
                    ></circle>
                </svg>
            }
            @for (loader of loaders; track loader) {
                <div
                    *transloco="let t"
                    [innerHtml]="
                        loader.options.messageKey
                            ? t(loader.options.messageKey)
                            : (loader.options.message | safe: 'SafeHtml')
                    "
                >
                </div>
            }
        </div>
    </div>
}
